@import "../../global/gx-ide-common.scss";
@import "../../global/gx-ide-mixins.scss";

:host {
  display: block;
}

.options {
  max-inline-size: 50%;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-m-large);
}
.message-item {
  display: flex;
  align-items: start;
  gap: var(--spacing-gap-m);
}
